<template>
  <Header />
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <Toast />
          <ConfirmDialog />

          <AstopiaTable ref="astopiaTable" :columns="columns" :url="'/admin/birth-chart-content/list/house-sign-content'"
                        :default-post-data="'?test=test'"
                        :axiosDataName="'data'" :sort-field="'id'" :totalDataName="'totalRecords'" :isOnlyNodata="true"
                        @detail-see="detailSee" @delet-see="deleteSee" @add-button="addInAppMessage"  :addButton="'Add Content'" @language-modal="showEditLanguage" :filtersObj="true" :isOnlydata="true" :postGetData="true" :dataPagination="false" :pagePagination="false" :optionsList="optionsList" :selectedObj3="true"/>
        </div>
      </div>

      <CreateModal
        :show="showCreateModal"
        modalTitle="Create Content"
        modalWidth="50%"
        :formFields="[
          { label: 'Language', type: 'select', model: 'language', placeholder: 'Enter Language', options: supportedLanguages , id: 'id', value: 'name' },
          { label: 'Title', type: 'text', model: 'title', required: false },
          { label: 'Text', type: 'textarea', model: 'text', required: false },
          { label: 'Ascendant Sign', type: 'select', model: 'signId', options: signs, id: 'id', value: 'name', required: true},
          { label: 'House', type: 'select', model: 'houseId', options: houses, id: 'id', value: 'name', required: true},
          { label: 'Planet', type: 'select', model: 'planetId', options: planets, id: 'id', value: 'name', required: true},
          { label: 'Gender', type: 'select', model: 'gender', options: [{ 'id': 0, 'value': 'All' }, { 'id': 1, 'value': 'Man' }, { 'id': 2, 'value': 'Woman' }], id: 'id', value: 'value', required: true},
        ]"
        @saveEndpoint="createObj"
        method="post"
        @hide="showCreateModal = false"
        @success="refreshTable"
      />

      <EditModal
        :show="showEditModal"
        modalTitle="Edit Content"
        modalWidth="50%"
        :formFields="[
          { label: 'Gender', type: 'select', model: 'gender', options: [{ 'id': 0, 'value': 'All' }, { 'id': 1, 'value': 'Man' }, { 'id': 2, 'value': 'Woman' }], value: 'id', text: 'value', required: true},
          { label: 'Sign Id', type: 'select', model: 'signId', options: signs, value: 'id', text: 'name', required: true},
          { label: 'House', type: 'select', model: 'houseId', options: houses, value: 'id', text: 'name', required: true},
          { label: 'Planet', type: 'select', model: 'planetId', options: planets, value: 'id', text: 'name', required: true},

        ]"
        :detailEndpoint="`/admin/birth-chart-content/${selectedObjId}`"
        @saveEndpoint="editObj"
        method="get"
        :totalDataName="''"
        :isOnlyNodata="true"
        @hide="showEditModal = false"
          />

      <TranslationsModal
        :show="showEditLanguageModal"
        @hide="showEditLanguageModal = false"
        :contentId="editTranslationContentId"
        :type="'house-sign-content'"
        @success="refreshTable"
      />

      <DeleteModal
        :show="showDeleteModal"
        :itemId="selectedDeleteId"
        modalTitle="Delete Content"
        deleteMessage="Are you sure you want to delete this content?"
        confirmButtonText="Yes"
        :deleteEndpoint="`/admin/birth-chart-content/${selectedDeleteId}`"
        @update:isVisible="showDeleteModal = false"
        @delete-success="refreshTable"
      />
    </div>
  </main>
</template>

<script>
import Header from "@/components/Header.vue";
import dayjs from "dayjs";
import AstopiaTable from "../../components/Tables/AstopiaTable.vue";
import TranslationsModal from "../Modals/TranslationsModal.vue";
import { mapGetters } from "vuex";
import 'quill/dist/quill.snow.css';

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

export default {
  name: "BirthChartHouseContent",
  components: {
    Header,
    AstopiaTable,
    TranslationsModal
  },
  data() {
    return {
      columns: [
        {field: "id", header: "Id", functionType: "none", selected: true},
        {field: "title", header: "Title", functionType: "none", selected: true},
        {field: "text", header: "Text", functionType: "none", selected: true},
        {field: "type", header: "Type", functionType: "none", selected: true},
        {field: "signId", header: "Sign", functionType: "signId", selected: true},
        {field: "houseId", header: "House", functionType: "houseId", selected: true},
        {field: "planetId", header: "Planet", functionType: "planetId", selected: true},
        {field: "gender", header: "Gender", functionType: "gender", selected: true},
        {field: "createdDate", header: "Created Date", functionType: "Date", selected: true},
        {field: "lastUpdateDate", header: "Last Update Date", functionType: "Date", selected: true},
        {field: "Actions", header: "Actions", functionType: "crud", edit: true, delete: true, selected: true, translations: true},
      ],
       data:{
        "id": 0,
        "type":"",
        "title": "",
        "text": "",
        "houseId": 0,
        "planetId": 0,
        "gender": 0,
        "signId": 0,
        "language": "",
        "autoTranslate": true
      },
      dataUpdate:{
        "id": 0,
        "houseId": 0,
        "planetId": 0,
        "gender": 0,
        "signId": 0,
        "language": "",
        "autoTranslate": true
      },
      loading: false,
      genders: [{ id: 0, name: "All" }, { id: 1, name: "Man" }, { id: 2, name: "Woman" }],
      showCreateModal: false,
      showEditLanguageModal: false,
      showDeleteModal: false,
      showEditModal: false,
      editTranslationContentId: 0,
      selectedDeleteId: null,
      optionsList: [],
    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['signs', 'houses', 'planets', 'supportedLanguages']),
  },
  created(){
    this.$appAxios.get("admin/global/supported-languages")
      .then(resp => {
        this.optionsList = resp.data
      })
      .catch(err => {
        console.log(err)
      });
  },
  methods: {
    addInAppMessage() {
      this.showCreateModal = true
    },
    deleteSee(report) {
      this.selectedDeleteId = report.id
      this.showDeleteModal = true
    },
    detailSee(obj){
      this.selectedObjId = obj.id
      this.showEditModal = true
    },
    showEditLanguage(obj) {
      this.editTranslationContentId = obj.id;
      this.showEditLanguageModal = true;
    },
    refreshTable() {
      this.$refs.astopiaTable.getData();
    },
    createObj(obj) {
      this.data.type = "house-sign-content"
      this.data.gender = obj.gender;
      this.data.signId = obj.signId;
      this.data.houseId = obj.houseId;
      this.data.planetId = obj.planetId;
      this.data.language = obj.language;
      this.data.text = obj.text;
      this.data.title = obj.title;
      this.data.autoTranslate = true;
      this.$appAxios.post("/admin/birth-chart-content/v2/house-sign-content", this.data, {
      headers: {
        "Accept-Language": obj.language || "en"
      }
    }).then(() => {
        this.refreshTable()
        this.showCreateModal = false
      }).catch(() => {
        this.showCreateModal = false
      })
    },
    editObj(obj) {
      this.dataUpdate.id = obj.id;
      this.dataUpdate.signId = obj.signId;
      this.dataUpdate.houseId = obj.houseId;
      this.dataUpdate.planetId = obj.planetId;
      this.dataUpdate.gender = obj.gender;
      this.dataUpdate.isGeneral = obj.isGeneral;
      this.dataUpdate.type = "house-sign-content";

      this.$appAxios.put("/admin/birth-chart-content", this.dataUpdate).then(() => {
        this.refreshTable()
        this.showEditModal = false
      }).catch(() => {
        this.showEditModal = false
      })
    },
  },
};
</script>
<style scoped>
.p-button-sm {
  height: 35px;
  width: 35px;
  font-size: 0.875rem;
  padding: 0.7rem;
}

.p-disabled,
.p-component:disabled {
  opacity: 0.8;
}

.p-dropdown {
  min-width: 200px;
}
</style>